import { render, staticRenderFns } from "./PlayerScore.vue?vue&type=template&id=38561db2&scoped=true&"
import script from "./PlayerScore.vue?vue&type=script&lang=js&"
export * from "./PlayerScore.vue?vue&type=script&lang=js&"
import style0 from "./PlayerScore.vue?vue&type=style&index=0&id=38561db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38561db2",
  null
  
)

export default component.exports